import React from 'react';
import { Box, Grid } from '@mui/material';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

import SceneContextFactsCard from 'app/components/ScenarioEditorPage/ScenarioSettingsDialog/SceneContextFactsCard.tsx';
import type { ScenarioSettingsType } from 'app/components/ScenarioEditorPage/ScenarioSettingsDialog/hooks/useScenarioForm.ts';
import ScenarioContextLocationsCard from 'app/components/ScenarioEditorPage/ScenarioSettingsDialog/SceneContextLocationsCard.tsx';
import { useQuery } from '@tanstack/react-query';

type ScenarioContextSettings = {
  scenarioId?: number;
};

const ScenarioContextSettings: React.FunctionComponent<ScenarioContextSettings> = ({ scenarioId }) => {
  const { control } = useFormContext<ScenarioSettingsType>();

  return (
    <Box sx={{ mt: 5, mb: 3 }}>
      <Box>
        <Controller
          control={control}
          name={`context.id` as const}
          render={({ field: inputField }) => <input type="hidden" {...inputField} />}
        />
        <Grid container spacing={2}>
          <Grid container item xs={6}>
            <Grid item xs={12}>
              <SceneContextFactsCard />
            </Grid>
          </Grid>
          <Grid item container xs={6} direction="column" spacing={2}>
            <Grid item>
              <ScenarioContextLocationsCard />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ScenarioContextSettings;
